export default __webpack_public_path__ + "static/media/congrats.876ffd82.png";